
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, forkJoin, Subject } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoaderService } from 'src/app/core/loader.service';
import { ToastService } from 'src/app/core/toast.service';
import { MethodValidityService } from 'src/app/immigration/services/validations/method-validity.service';
import { nullSafe } from 'src/app/utils';
import { Logger } from 'src/app/utils/Logger';
import { getDateAsUTC, isNullOrUndefined } from '../../../app/core/utils';
import {
    Address, AirportDetails, ArabicNames, AuthorisedHub, BankDetails, CandidateApi,
    CandidateDocuments, CandidateProfile,

    CandidateProfileAdditionalDetails, CombainedProfile,
    Comments, DocumentType, EmergencyDetailsData, Employee, EmployeeAdditionalDetails, FamilyBookDetails, HttpStatusCode,

    ItFinacialInformation, ItITInformation, ItLeaveInformation, ItPersonalInfo, KinDetails, LookupField,

    MedicalInsuranceDetails, Nationalities, PBProfile,
    PreferedName,
    RankGrade, Speciality, TravelPlans, VehicleData, LastEmployer, CandidateDocCombined,
    RoleType,
    EAAllocator,
} from "../../core/api.gen";
import { CommentTypes } from '../comment-types';
import { FormCanDeactivate } from '../form/form-can-deactivate';
import { findInvalidControlTab, invalidDataCheck, isInternalTransfer } from '../form/form-validators';
import { LookupTypeKeys } from '../lookup-type-keys';
import { StepType } from '../shared.module';
import { StatusTypes } from '../status-types';
import { CandidateProfileMachineService } from './candidate-profile-machine.service';
import { APPROVE, REJECT, SAVE, SENDINVITE, SUBMIT } from './candidate-profile.sm';
import { ProfileStepService } from "./profile-step.service";

@Component({
  selector: "eos-candidate-profile",
  templateUrl: "./candidate-profile.component.html"
})
export class CandidateProfileComponent extends FormCanDeactivate implements OnInit, OnDestroy {

  @ViewChild('fileField') element: ElementRef;

  destroy$: Subject<any>;
  profileId: number;
  isRecruitment = false;
  isApprove = false;

  model: CandidateProfile;

  steps: StepType[];
  additionalSteps: StepType[];
  uploadedFiles: CandidateDocCombined[] = [];
  formArray: UntypedFormArray;
  pbFormArray: UntypedFormArray;
  disableUpload = false;
  activeTabIdx = 0;
  pbProfile: PBProfile;
  lookupType: number;
  documentTypes: DocumentType[] = [];
  validatecheck = true;
  comment: Comments;
  oldNotes: string = null;
  disableButton = false;
  candidateInfo: string;
  employeeStatus: string;
  isInvite: boolean;
  //rpProfile: CandidateProfileAdditionalDetails;
  rpSteps: StepType[];
  rpForm: UntypedFormArray;
  showRpInfo: boolean = false;


  constructor(
    private stepService: ProfileStepService,
    private candidateApi: CandidateApi,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private toast: ToastService,
    private common: CommonService,
    private loader: LoaderService,
    private dialog: DialogService,
    private fsm: CandidateProfileMachineService,
    private validations: MethodValidityService,
    private authService: AuthService

  ) {
    super();
  }

  private _header = 'Candidate profile';
  get header() {
    return this._header;
  }

  GetDocuments($event) {
    this.uploadedFiles = $event;
  }
  get enableSave(): boolean {
    return this.rpForm.dirty || this.formArray.dirty || ((this.oldNotes || 0) !== (this.model.notes || 0))
  }
  ngOnInit(): void {
    this.activeRoute.data.subscribe(rd => {
      this._header = nullSafe(() => rd.name.replace("Pre-board", "Pre-join"), this._header);
      this.isInvite = nullSafe(() => rd.isInvite, false);
    });
  
    this.activeRoute.params.subscribe(routeParams => {
      if (routeParams.id && routeParams.id > 0) {
        this.profileId = routeParams.id;
        this.loadDropdownData().subscribe(() => {
          this.loadCombainedProfile(routeParams.id);
        });
      }
    });
  
    this.initCandidateProfile();
    this.initPreHireProfile();
    this.destroy$ = this.common.getDestroyed();
    this.profileId = -1;
    this.isRecruitment = this.common.isRecruitment;
    this.lookupType = LookupTypeKeys.RECRUITMENT_DOCUMENT_TYPES;
    this.initializeStepService();
    this.initializeFormArrays();
    this.initializeFsm();
    this.activeTabIdx = 0;
  }
  private loadDropdownData() {
    return forkJoin([
      this.common.prepareLookupObservable(LookupTypeKeys.ONBOARDING_TYPES),
      this.common.prepareLookupObservable(LookupTypeKeys.NATIONALITY_TYPE),
      this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION_COUNTRY),
      this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION),
      this.common.prepareOfficeEntityObservable(),
      this.common.prepareCitiesObservable(),
      this.common.prepareEmployeeCategoryLookupObservable(LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES),
      this.common.prepareContractTypeLookupObservable(LookupTypeKeys.CONTRACT_TYPES),
      this.common.prepareServiceLineObservable(),
      this.common.prepareSubServiceLineObservable(),
      this.common.prepareAuthHubObservable(),
      this.common.prepareSectorObservable(),
      this.common.prepareSMUObservable(),
      this.common.prepareSpecialityObservable(),
      this.common.prepareLookupObservable(LookupTypeKeys.RANK),
      this.common.prepareEmployeeByRoleObservable(RoleType.PTC),
      this.common.prepareEmployeeByRoleObservable(RoleType.Recruiter),
      this.common.prepareLookupObservable(LookupTypeKeys.PREVIOUS_EY_EXPERIENCE),
      this.common.prepareLookupObservable(LookupTypeKeys.GENDER),
      this.common.prepareLookupObservable(LookupTypeKeys.HIRE_TYPE),
      this.common.prepareLookupObservable(LookupTypeKeys.YESNONA_TYPES),
      this.common.prepareLookupObservable(LookupTypeKeys.YESNO_TYPES),
      this.common.prepareLookupObservable(LookupTypeKeys.VACCINATION_STATUS),
      this.common.prepareLookupObservable(LookupTypeKeys.VACCINE_TYPE),
      this.common.prepareLookupObservable(LookupTypeKeys.MARITAL_STATUS),
      this.common.prepareLookupObservable(LookupTypeKeys.RELIGION),
      this.common.prepareLookupObservable(LookupTypeKeys.RP_CURRENT_EMPLOYEMENT_STATUS),
      this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION),
      this.common.prepareLookupObservable(LookupTypeKeys.NATIONALITY),
      this.common.prepareLookupObservable(LookupTypeKeys.TRAVEL_TIME_PREFERNCE),
      this.common.prepareLookupObservable(LookupTypeKeys.NO_OF_DEPENDENTS),
      this.common.prepareLookupObservable(LookupTypeKeys.EOSB),
      this.common.prepareLookupObservable(LookupTypeKeys.MANAGE_LEAVE_BALANCE),
      this.common.prepareLookupObservable(LookupTypeKeys.SHORT_TRAVEL_TYPE),
      this.common.prepareLookupObservable(LookupTypeKeys.CHOICE_OF_INSURANCE),
      this.common.prepareLookupObservable(LookupTypeKeys.YES_NO_INITATED),
      this.common.prepareLookupObservable(LookupTypeKeys.BIGFOURCOMPANIES)
     ]);
  }

  
  // private updateFormControls() {
  //   this.formArray.patchValue(this.model);
  //   this.pbFormArray.patchValue(this.pbProfile);
  //   this.rpForm.patchValue(this.model.candidateProfileAdditionalInfo);
  // }
  
  private initializeStepService() {
    this.stepService.isCountryARE = () => this.isCountryARE();
    this.stepService.isLocationLevant = () => this.isLocationLevant();
    this.stepService.rpAdditionalInfo = () => this.displayRpAdditionalInfo();
    this.stepService.isInternationalHire = () => this.isInternationalHire();
    this.stepService.isCNICNeeded = () => this.isCNICNeeded();
    this.stepService.isRapidInnovation = () => this.isRapidInnovation();
    this.stepService.isLevantNational = () => this.isLevantNational();
    this.stepService.isInternalTransfer = () => this.isInternalTransfer();
    this.stepService.isPbNational = () => this.isPbNational();
    this.stepService.modelDetails = () => this.modelDetails();
    this.stepService.isIntern = () => this.isIntern();
    this.stepService.isRapidOrPakistan = () => this.isRapidInnovationOrPakistan();
    this.stepService.rank = () => this.rank();
    this.stepService.officeLocation = () => this.officeLocation();
    this.stepService.validateAcademicAttesation = () => this.validateAcademicAttesation();
    this.stepService.isPreviousEmployment = () => this.isPreviousEmployment();
    this.stepService.cw_contractTypesExcludingFTTE = () => this.cw_contractTypesExcludingFTTE();
    this.stepService.isNationalInternalTransferWithinSameOffice = () => this.isNationalInternalTransferWithinSameOffice();
  }
  
  private initializeFormArrays() {
    this.steps = this.stepService.getProfileSteps(this.isInvite);
    this.additionalSteps = this.stepService.getAdditionalPbSteps(this.model);
    this.rpSteps = this.stepService.getRpProfileStep();
    this.formArray = new UntypedFormArray(this.steps.map(() => new UntypedFormGroup({})));
    this.pbFormArray = new UntypedFormArray(this.additionalSteps.map(() => new UntypedFormGroup({})));
    this.rpForm = new UntypedFormArray(this.rpSteps.map(() => new UntypedFormGroup({})));
  }
  
  private initializeFsm() {
    this.fsm.isRecruiter = (ctx, evt) => this.common.isRecruitment && this.authService.isAuthorised('CanEdit-RMT');
    this.fsm.isPTC = (ctx, evt) => !this.common.isRecruitment;
    this.fsm.canApprove = (ctx, evt) => !this.common.isRecruitment && this.authService.isAuthorised('CanApproveProfile-PTC');
    this.fsm.isInvite = (ctx, evt) => this.common.isRecruitment && this.authService.isAuthorised('CanEdit-RMT') && this.isInvite;
    this.fsm.isRecruiterReject = (ctx, evt) => this.common.isRecruitment && this.authService.isAuthorised('CanEdit-RMT') &&
      !this.model.candidateProfileAdditionalInfo.isRejectedForCandidate;
    this.fsm.start();
  }
  displayRpAdditionalInfo() {
    this.showRpInfo = !this.showRpInfo;
    if (this.isInvite == true) {
      this.rpForm.disable();
    }
  }
  private initCandidateProfile() {
    // object had to be instantiated for validation purpose at api.gen, it couldnt be null
    this.model = new CandidateProfile();
    this.model.onboardingType = new LookupField();
    this.model.nationalityType = new LookupField();
    this.model.officeLocationCountry = new LookupField();
    this.model.officeLocation = new LookupField();
    this.model.officeLegalEntity = new LookupField();
    this.model.employeeCategory = new LookupField();
    this.model.serviceLine = new LookupField();
    this.model.subServiceLine = new LookupField();
    this.model.subSubServiceLine = new LookupField();
    this.model.sector = new LookupField();
    this.model.smu = new LookupField();
    this.model.speciality = new Speciality();
    // this.model.rank = new LookupField();
    // this.model.grade = new LookupField();
    this.model.contractType = new LookupField();
    this.model.previousEYExperience = new LookupField();
    this.model.gender = new LookupField();
    this.model.nationality = new LookupField();
    this.model.otc = new Employee();
    this.model.recruiter = new Employee();
    this.model.hireType = new LookupField();
    this.model.status = new LookupField();
    this.model.isBRIT = new LookupField();
    this.model.biLingual = new LookupField();
    this.model.job = new RankGrade();
    this.model.authorisedHub = new AuthorisedHub();
    this.model.vaccinationStatus = new LookupField();
    this.model.vaccineType = new LookupField();
    this.model.eAallocatorData = new EAAllocator();
    this.pbProfile = new PBProfile();
    this.comment = new Comments();
    this.model.createdVia = this.isInvite ? 'IV' : null;
    this.model.candidateProfileAdditionalInfo = this.initPreHireProfile();
  }

  private initPreHireProfile() {
    let additionalProfile = new CandidateProfileAdditionalDetails();
    additionalProfile.arabicName = new ArabicNames();
    additionalProfile.address = new Address();
    additionalProfile.bankDetails = new BankDetails();
    additionalProfile.additionalInfo = new EmployeeAdditionalDetails();
    additionalProfile.emergencyDetails = new EmergencyDetailsData();
    additionalProfile.insuranceDetils = new MedicalInsuranceDetails();
    additionalProfile.vehicleDetails = new VehicleData();
    additionalProfile.travelPlan = new LookupField();
    additionalProfile.currentEmploymentStatus = new LookupField();
    additionalProfile.previousEmployee = new LookupField();
    additionalProfile.previousEyLocation = new LookupField();
    additionalProfile.religion = new LookupField();
    additionalProfile.nationalities = new Nationalities();
    additionalProfile.professionalQualificationAttested = new LookupField();
    additionalProfile.academicQualificationAttested = new LookupField();
    additionalProfile.localRecruit = new LookupField();
    additionalProfile.overseasRecruit = new LookupField();
    additionalProfile.residentHiringOffice = new LookupField();
    additionalProfile.noticePeriodNegotiable = new LookupField();
    additionalProfile.additionalInfo.fathersReligion = new LookupField();
    additionalProfile.additionalInfo.mothersReligion = new LookupField();
    additionalProfile.preferredMail= new PreferedName();
    additionalProfile.preferredMail.isPreferedNameApplicable=new LookupField();
    additionalProfile.additionalInfo.fathersNationality = new LookupField();
    additionalProfile.additionalInfo.mothersNationality = new LookupField();
    additionalProfile.insuranceDetils.insuranceExist = new LookupField();
    additionalProfile.insuranceDetils.isItGovtInsurance = new LookupField();
    additionalProfile.travelPlans = new TravelPlans();
    additionalProfile.travelPlans.isDependentsTravelling = new LookupField();
    additionalProfile.travelPlans.preferredTravelTime = new LookupField();
    additionalProfile.travelPlans.familyMembersRelocating = new LookupField();
    additionalProfile.travelPlans.closestInternationalAirport = new AirportDetails();
    additionalProfile.travelPlans.dependentTravelingCount = new LookupField();
    additionalProfile.itPersonalInfo = new ItPersonalInfo();
    additionalProfile.itPersonalInfo.istravellingShortly = new LookupField();
    additionalProfile.itPersonalInfo.holdEmploymentVisa = new LookupField();
    additionalProfile.itPersonalInfo.isBusinessTrip = new LookupField();
    additionalProfile.itPersonalInfo.travelLocation = new LookupField();
    additionalProfile.itPersonalInfo.isEngagedInAnyProject = new LookupField();
    additionalProfile.itITInformation = new ItITInformation();
    additionalProfile.itITInformation.haveAccesstoMailbox = new LookupField();
    additionalProfile.itITInformation.dicussedRequirementWithITteam = new LookupField();
    additionalProfile.itITInformation.haveCurrentOfficeEquipment = new LookupField();
    additionalProfile.itLeaveInformation = new ItLeaveInformation();
    additionalProfile.itLeaveInformation.havingOutstandingLeave = new LookupField();
    additionalProfile.itLeaveInformation.howToManageLeave = new LookupField();
    additionalProfile.itFinacialInformation = new ItFinacialInformation();
    additionalProfile.itFinacialInformation.isAmexCardAvailable = new LookupField();
    additionalProfile.itFinacialInformation.eosb = new LookupField();
    additionalProfile.itFinacialInformation.havingOutstandingLoans = new LookupField();
    additionalProfile.itFinacialInformation.haveOutstandingreimbursements = new LookupField();
    additionalProfile.kinDetails = new KinDetails();
    additionalProfile.familyBookDetails = new FamilyBookDetails();
    additionalProfile.familyBookDetails.haveFamilyBook = new LookupField();
    additionalProfile.choiceOfMedicalInsurance = new LookupField();
    additionalProfile.previousBigFour = new LookupField();
    additionalProfile.previousEyEmployee = new LookupField();
    additionalProfile.lastEmployerDetail = new LastEmployer();
    additionalProfile.lastEmployerDetail.lastEmployerLocation = new LookupField();
    additionalProfile.registeredWithUAE = new LookupField();
    additionalProfile.gender = new LookupField();
    return additionalProfile;
  }


  get canInvite(): boolean {
    return this.canExecute('SENDINVITE');
  }
  get canSave(): boolean {
    return this.canExecute('SAVE');
  }

  get canSubmit(): boolean {
    return this.canExecute('SUBMIT');
  }

  get canApprove(): boolean {
    return this.canExecute('APPROVE');
  }

  get canReject(): boolean {
    return this.canExecute('REJECT');
  }
  get canCancelInvite(): boolean {
    return this.canExecute('CANCELINVITE');
  }

  get canResendInvite(): boolean {
    return this.canExecute('RESENDINVITE');
  }

  get isPTC(): boolean {
    return this.fsm.isPTC();
  }

  canExecute(event: string): boolean {
    return this.fsm.getValidEvents().indexOf(event) >= 0;
  }

  get isEditable(): boolean {
    return this.canSave || this.canReject || this.canApprove || this.canSubmit;
  }

  get ifUploadOnly() {
    if (!this.isEditable && this.authService.ActiveUser.features.includes('UploadOnly-PTC')) {
      return true;
    }
    return false;
  }

  get canUploadDocuments(): boolean {
    return !(isNullOrUndefined(this.profileId) || this.profileId <= 0);
  }

  get allowDocCall() {
    return (this.validations.ifFieldNull(this.model)) ? false : true;
  }

  setDocList($event) {
    this.documentTypes = $event;
  }

  private loadCombainedProfile(id: number) {
    this.loader.show();
    this.candidateApi.getCombainedProfile(id).pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(resp => {
      this.model = resp.candidateProfile;
      this.model.transferScenarioID = resp.pbProfile.transferScenarioID;
      this.model.transferTypeID = resp.pbProfile.transferTypeID;
      this.bindAdditionalPBSteps();
      this.model.candidateProfileAdditionalInfo.gender = this.model.gender;
      this.model.candidateProfileAdditionalInfo.dateOfBirth = this.model.dateOfBirth;
      this.candidateInfo = this.common.getcandidateInfo(this.model);
      this.profileId = resp.candidateProfile.id;
      this.oldNotes = this.model.notes;
      this.pbProfile = resp.pbProfile;
      this.employeeStatus = this.common.getemployeeStatus(resp.pbProfile.pbStatus.id, resp.candidateProfile.empStatus);
      this.fsm.start(this.getFsmStateFromProfile(this.pbProfile));
      //this.updateFormControls();
      if (this.model.createdVia == "IV") {
        let academicqualificationfield = this.getFormControl(this.formArray, 'academicQualification');
        if (academicqualificationfield) {
          academicqualificationfield.disable();
        }
      }
      if (this.model.createdVia == "IV" && ![717, 722].includes(this.model.employeeCategory.id)) {
        let previouseyexperiencefield = this.getFormControl(this.formArray, 'previousEYExperience.id');
        if (previouseyexperiencefield) {
          previouseyexperiencefield.disable();
        }
      }
      this.observeAndUpdateImmCaseType();
      if (!this.isEditable) {
        this.formArray.disable();
        this.pbFormArray.disable();
        this.rpForm.disable();
      }
      if (this.model.status != null && this.model.status.id == StatusTypes.CANCELLEDINVITE) {
        this.toast.warning('This is a cancelled invitation, please update the required field in order to send a new invitation.');
      }
      if (this.model.createdByEmployee && this.model.createdByEmployee.email == 'SYS_USR_MAIL@gds.ey.com') {
        let emailfield = this.getFormControl(this.formArray, 'emailID');
        if (emailfield) {
          emailfield.disable();
        }
      }
    });
  }

  getFsmStateFromProfile(pbp: PBProfile) {
    // tslint:disable-next-line:prefer-const
    let currPBStatus = nullSafe(() => pbp.pbStatus.id, -1);
    switch (currPBStatus) {
      case StatusTypes.DRAFT:
        return 'draft';
      case StatusTypes.PENDING:
        if (!this.isRecruitment
          && !this.authService.ActiveUser.features.includes('CanEdit-PTC')) {
          return 'inprogress';
        }
        return 'submitted';
      case StatusTypes.APPROVED:
        return 'approved';
      case StatusTypes.REJECTED:
        return 'rejected';
      case StatusTypes.INPROCESS:
        return 'inprogress';
      case StatusTypes.CANCELLEDINVITE:
        return 'cancelledInvite';
      case StatusTypes.INVITED:
        return 'invited';


      default:
        return 'inprogress';
    }
  }


  showTab(idx: number) {
    if (idx === this.steps.length) {
      if (!this.canUploadDocuments) {
        return;
      }
    }
    this.activeTabIdx = idx;
    if (this.activeTabIdx == 3) {
      this.additionalSteps = this.stepService.getAdditionalPbSteps(this.model);
    }
  }

  get showingFileUpload() {
    return this.activeTabIdx === this.steps.length;
  }

  approveProfile() {
    const combProf = new CombainedProfile({ candidateProfile: this.model, pbProfile: this.pbProfile });

    if (
      !this.validations.incorrectDataMulForms([this.formArray, this.pbFormArray, this.rpForm])
      || !this.validations.validateMultipleForms([this.formArray, this.pbFormArray, this.rpForm])) {

      if (this.formArray.invalid) {
        this.navigateToFirstInvalidTab(this.formArray);
      } else if (this.pbFormArray.invalid) {
        this.showTab(3);
      } else if (this.rpForm.invalid) {
        this.showTab(2);
      }

      return;
    }



    // if (!this.validations.docMandatory(this.documentTypes, this.getdistinctDocs)) {
    //   this.toast.warning("Please upload all mandatory documents");
    //   return;
    // }
    if (isInternalTransfer(combProf, this.toast)) {
      return;
    }

    this.dialog.showApprovalBox((cmt) => {
      this.comment.commentType = CommentTypes.Preboarding;
      this.comment.candidateProfileId = this.profileId;
      this.comment.comment = this.trimNotesAndComments(cmt.Comment);

      this.loader.show();

        

    const pathWithProp  = 
    ["startDate","dateOfBirth","invitedDate","recruitmentHandoverDate","epRequestedDate","epCreatedDate",
    "candidateProfileAdditionalInfo.currentVisaExpiryDate",
    "candidateProfileAdditionalInfo.earliestJoiningDate",
    "candidateProfileAdditionalInfo.nationalities.cnicExpiryDate",
    "candidateProfileAdditionalInfo.itPersonalInfo.travellingDate",
    "candidateProfileAdditionalInfo.married.marriageDate",
    "candidateProfileAdditionalInfo.itPersonalInfo.transferDate",
    "candidateProfileAdditionalInfo.attestationCompletedDate",
    "candidateProfileAdditionalInfo.lastEmployerDetail.lastEmployerStartDate",
    "candidateProfileAdditionalInfo.lastEmployerDetail.lastEmployerEndDate",
    "startDateCW","confirmedEnddateCW","lastWorkingday"
    ];
    this.common.updateDateProperty(this.model, pathWithProp);

    const pathWithPBProp  = 
    ["pbInitiationdatebyPTC",
    "marriageEffectiveDate","lastWorkingday",
    "epCreatedDate","epRequestedDate","previousStartdate",
    "startdate","confirmedEnddate","startdateCW","confirmedEnddateCW",
    "eyApprovedVisaDate","entryPermitExpiryDate",
    "empDateOfIntiation","empDateOfCompletion","depDateOfIntiation",
    "depDateOfCompletion","bookingInitiationDate","bookingCompletionDate","documentExpectedDate",
    "exceptionValidityVisaJobTitleChangeStatus","exceptionValidityDocAttestStatus","exceptionValidityJoiningWithoutValidWorkPermit",
    "durationItClearance","durationHomeCountryVisaCancellationStatus",
    "educationDocumentProcurementforAttestationRequestInitiatedDate","educationDocumentProcurementforAttestationDocumentscollectedDate",
"educationDocumentProcurementforAttestationAssesmentDate","educationDocumentProcurementforAttestationCompletedDate",
"documentProcurementforWorkPermitInitiatedDate","documentProcurementforWorkPermitCollectedDate","documentProcurementforWorkPermitAssesmentDate",
"documentProcurementforWorkPermitCompletedDate","educationDocumentAttestationInitiatedDate","educationDocumentAttestationUnderProcessDate",
"educationDocumentAttestationCompletedDate","exceptionApprovalWorkPermitInitiatedDate","exceptionApprovalWorkPermitApprovalReceivedDate",
"corporateDocumentInitiatedDate","corporateDocumentReceivedByVendorDate","corporateDocumentAssesmentDate",
"corporateDocumentCompletedDate","visaReTaggingInitiatedDate","visaReTaggingCompletedDate","revisedCorporateDocumentInitiatedDate",
"revisedCorporateDocumentReceivedByVendorDate","revisedCorporateDocumentAssesmentDate","revisedCorporateDocumentCompletedDate","mosadaqaInitiatedDate",
"mosadaqaUnderProcessDate","mosadaqaCompletedDate","qvpInitiatedDate","qvpUnderProcessDate","qvpCompletedDate",
"professionalMembershipCertificateInitiatedDate","professionalMembershipCertificateUnderProcessDate",
"professionalMembershipCertificateCompletedDate","businessVisaCancellationLetterInitiatedDate","businessVisaCancellationLetterCompletedDate",
 "wpApplicationNJMedicalAppointmentDate","wpApplicationNJMedicalProcessCompletedDate","wpApplicationNJPCCAppointmentDate",
"wpApplicationNJPCCProcessCompletedDate","wpApplicationNJBiometricsAppointmentDate","wpApplicationNJBiometricsProcessCompletedDate",
"wpApplicationNJHomeCountryVisaStampingProcessDate","wpApplicationNJHomeVisaStampedIssuedDate","wpApplicationEYInitiatedDate",
"wpApplicationEYQVCAppointmentDate","wpApplicationEYEmbassyAppointmentDate","wpApplicationEYWorkPermitIssuedDate",
"laborContractReceivedImmigrationDate","laborContractSharedWithEmployeeDate","laborContractReceivedFromEmployeeDate",
"laborContractSharedWithImmigrationDate","homeCountryExitFormalityInitiatedDate","homeCountryExitFormalityUnderProcessDate",
"homeCountryExitFormalityCompletedDate","travelBookingInitiatedDate","travelBookingCompletedDate"
    ];
  this.common.updateDateProperty(this.pbProfile, pathWithPBProp);
     
    
      this.disableButton = true;
      const profile = new CombainedProfile();
      this.comment.statusId = StatusTypes.APPROVED;

      // Intern
      if (this.model.employeeCategory.id === 715) {
        this.pbProfile.ccgLeadId = null;
        this.pbProfile.cftLeadId = null;
        this.pbProfile.ccgLeadData = null;
        this.pbProfile.cftLeadData = null;
        this.model.contractDuration = null;
      }
      if (this.model.employeeCategory.id !== 715) {
        this.model.contractDurationIntern = null;
      }    
      this.pbProfile.citizenshipId = this.common.getCitizenshipBasedOnNationality(this.model.nationality.id);
      profile.candidateProfile = this.model;
      profile.pbProfile = this.pbProfile;
      profile.comment = this.comment;
      this.candidateApi.approveProfile(profile).pipe(catchError((err: HttpErrorResponse) => {
        return this.toast.handleServerValidationMessage(err);
      }), finalize(() => {
        this.loader.clear();
        this.disableButton = false;
      })).subscribe(resp => {
        if (resp.errorCode === 2002) {
          this.toast.warning("Email not sent");
        }
        this.toast.success("Profile Approved!");
        this.fsm.send(new APPROVE());
        //  this.router.navigateByUrl('/pre-boarding/candidates');
        this.router.navigateByUrl(`pre-boarding/candidate-activities/${this.profileId}`);
      });

    });
  }


  rejectProfile() {
    this.dialog.showRejectionBox((cmt) => {
      this.comment.commentType = CommentTypes.Preboarding;
      this.comment.candidateProfileId = this.profileId;
      this.comment.comment = this.trimNotesAndComments(cmt.Comment);
      this.loader.show();
      this.disableButton = true;
      this.comment.statusId = StatusTypes.REJECTED;
      this.comment.candidateMailSent = cmt.CandidateSent;


      this.candidateApi.rejectProfile(this.profileId, this.comment).pipe(catchError((err: HttpErrorResponse) => {
        return this.toast.handleServerValidationMessage(err);
      }), finalize(() => {
        this.loader.clear();
        this.disableButton = false;
      })).subscribe(resp => {
        if (resp.errorCode === 2002) {
          this.toast.warning("Email not sent");
        }
        this.toast.success("Profile Rejected!");
        this.fsm.send(new REJECT());
        this.router.navigateByUrl('/pre-boarding/candidates');
      });

    }, this.createdViaStatus());
  }

  createdViaStatus(): string {
    return nullSafe(() => this.model.createdVia == "IV" ? "Send mail to candidate?" : "")
  }

  next(tab: number) {
    if (tab > 3 || tab < 0) {
      return;
    }

    this.activeTabIdx = tab;
    if (this.activeTabIdx == 3) {
      this.additionalSteps = this.stepService.getAdditionalPbSteps(this.model);
    }
  }
  
   
  

  save(model: CandidateProfile, isSubmit: boolean) {

    if (invalidDataCheck(this.formArray)) {
      this.showTab(findInvalidControlTab(this.formArray));
      this.toast.warning("Can't save profile: please enter valid data!");
      return EMPTY;
    }
    //this.model.candidateProfileAdditionalInfo = this.rpProfile;
    if (this.profileId > 0 && nullSafe(() => this.model.id, 0) <= 0) {
      this.model.id = this.profileId;
    }
    this.profileId = 0;
    this.adaptModelIfInvite(model);

    this.loader.show();
    this.disableButton = true;



    const pathWithProp  = 
    ["startDate","dateOfBirth","invitedDate","recruitmentHandoverDate","epRequestedDate","epCreatedDate",
    "candidateProfileAdditionalInfo.currentVisaExpiryDate",
    "candidateProfileAdditionalInfo.earliestJoiningDate",
    "candidateProfileAdditionalInfo.nationalities.cnicExpiryDate",
    "candidateProfileAdditionalInfo.itPersonalInfo.travellingDate",
    "candidateProfileAdditionalInfo.married.marriageDate",
    "candidateProfileAdditionalInfo.itPersonalInfo.transferDate",
    "candidateProfileAdditionalInfo.attestationCompletedDate",
    "candidateProfileAdditionalInfo.lastEmployerDetail.lastEmployerStartDate",
    "candidateProfileAdditionalInfo.lastEmployerDetail.lastEmployerEndDate",
    "candidateProfileAdditionalInfo.dateOfBirth",
    "startDateCW","confirmedEnddateCW","lastWorkingday",
    ];
    this.common.updateDateProperty(this.model, pathWithProp);
     

    return this.candidateApi.saveProfile(isSubmit, this.model)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return this.toast.handleServerValidationMessage(err);
        }),
        map(result => {
          if (result.statusCode === HttpStatusCode.Created && result.data) {
            this.model = result.data;
            this.bindReorderedFields();
            this.bindAdditionalPBSteps();
            this.candidateInfo = this.common.getcandidateInfo(this.model);
            this.dispatchBuOuMu();
            this.profileId = result.data.id;
            this.common.candidateId = result.data.id;
            this.oldNotes = this.model.notes;
            this.fsm.send(new SAVE());
          }
        })
        , finalize(() => {
          this.loader.clear();
          this.disableButton = false;
        }));

  }

  dispatchBuOuMu() {
    const item = this.common.deptCodeBlock$
      .getValue()
      .find(f => f.deptCode === nullSafe(() => this.model.deptCode, "-1"));

    if (!!this.model && !!item) {
      this.model.buCode = item.buCode;
      this.model.ouCode = item.ouCode;
      this.model.muCode = item.muCode;
    }
  }

  trimNotesAndComments(text: string) {
    if (!isNullOrUndefined(text)) {
      text = text.trim();
      if (text.length === 0) {
        text = null;
      }
    } else { text = null; }
    return text;
  }

  get IsChanged(): boolean {
    this.model.notes = this.trimNotesAndComments(this.model.notes);

    if (!this.rpForm.dirty && !this.formArray.dirty && (this.oldNotes === this.model.notes)) {
      this.toast.warning("No changes to save!");
      return false;
    }
    return true;
  }

  get isAutoPopulated(): boolean {
    return nullSafe(() => this.model.createdByEmployee.email == "SYS_USR_MAIL@gds.ey.com", false);
  }

  adaptModelIfInvite(model: CandidateProfile) {
    if (model.status != null && model.status.id == StatusTypes.CANCELLEDINVITE) {
      const id = model.id;
      model.id = -13;
      model.referenceId = id;

    }
    return model;

  }

  saveDraft(model: CandidateProfile) {
    if (!this.IsChanged) {
      return EMPTY;
    }

    this.save(model, false).subscribe(result => {

      this.formArray.markAsPristine();
      this.toast.success("Profile saved successfully");
      if (model.id == -13) {
        this.router.navigateByUrl(`/recruitment/candidate-invite/${this.model.id}`);
      }
    });
  }

  saveAndContinue(model: CandidateProfile) {
    if (!this.IsChanged) {
      if (this.activeTabIdx <= this.steps.length) {
        this.showTab(this.activeTabIdx + 1);
      }
      return EMPTY;
    }
    this.save(model, false).subscribe(() => {
      if (this.activeTabIdx <= this.steps.length) {
        this.formArray.markAsPristine();

        this.showTab(this.activeTabIdx + 1);
      }
      if (model.id == -13) {
        this.router.navigateByUrl(`/recruitment/candidate-invite/${this.model.id}`);
      }
    });
  }


  onCancel() {
    if (this.isRecruitment) {
      this.router.navigateByUrl(`/recruitment/candidates`);
    } else {
      this.router.navigateByUrl(`/pre-boarding/candidates`);
    }
  }

  navigateToFirstInvalidTab(formArray: UntypedFormArray) {
    this.showTab(this.validations.GetIndexOfInvalidForm(formArray));
  }

  submit(model: CandidateProfile) {
    this.pbProfile.transferScenarioID = this.model.transferScenarioID;
    this.pbProfile.transferTypeID = this.model.transferTypeID;
    const combProf = new CombainedProfile({ candidateProfile: this.model, pbProfile: this.pbProfile });

    if (this.formArray.invalid) {
      this.formArray.markAllAsTouched();
      this.navigateToFirstInvalidTab(this.formArray);
      this.toast.warning("Please fill the mandatory fields");
      return;
    }

    if (this.rpForm.invalid) {
      this.rpForm.markAllAsTouched();
      this.navigateToFirstInvalidTab(this.rpForm);
      this.toast.warning("Please fill the mandatory fields");
      return;
    }

    if (isInternalTransfer(combProf, this.toast)) {
      this.showTab(2);
      return;
    }

    if (!this.validations.docMandatory(this.uploadedFiles)) {
      this.toast.warning("Please upload all mandatory documents");
      return;
    }
    this.loader.show();

    this.model.notes = this.trimNotesAndComments(this.model.notes);
    this.disableButton = true;

    const pathWithProp  = 
    ["startDate","dateOfBirth","invitedDate","recruitmentHandoverDate","epRequestedDate","epCreatedDate",
    "candidateProfileAdditionalInfo.currentVisaExpiryDate",
    "candidateProfileAdditionalInfo.earliestJoiningDate",
    "candidateProfileAdditionalInfo.nationalities.cnicExpiryDate",
    "candidateProfileAdditionalInfo.itPersonalInfo.travellingDate",
    "candidateProfileAdditionalInfo.married.marriageDate",
    "candidateProfileAdditionalInfo.itPersonalInfo.transferDate",
    "candidateProfileAdditionalInfo.attestationCompletedDate",
    "candidateProfileAdditionalInfo.lastEmployerDetail.lastEmployerStartDate",
    "candidateProfileAdditionalInfo.lastEmployerDetail.lastEmployerEndDate",
    "startDateCW","confirmedEnddateCW","lastWorkingday"
    ];
 
 
    this.common.updateDateProperty(this.model, pathWithProp);
    this.candidateApi.saveProfile(true, this.model).pipe(catchError((err: HttpErrorResponse) => {
      return this.toast.handleServerValidationMessage(err);
    }), finalize(() => {
      this.loader.clear();
      this.disableButton = false;
    })
    ).subscribe(result => {
      if (result.statusCode === HttpStatusCode.Created && result.data) {
        if (result.errorCode === 2002) {
          this.toast.warning("Email not sent");
        }
        this.formArray.markAsPristine();
        this.model = result.data;
        this.bindAdditionalPBSteps();
        this.profileId = result.data.id;
        this.common.candidateId = result.data.id;
        this.toast.success("Profile submitted successfully!");
        this.fsm.send(new SUBMIT());

        this.router.navigateByUrl(`/recruitment/candidates`);
      }
    }, error => {
      Logger.error(error);
    });
  }

  // get getdistinctDocs(): CandidateDocuments[] {
  //   let distinctDocs = [];
  //   if (this.uploadedFiles && this.uploadedFiles.length > 0) {
  //     distinctDocs = this.uploadedFiles.filter(
  //       (docType, i, arr) => arr.findIndex(t => t.documentId === docType.documentId) === i);
  //   }
  //   return distinctDocs;
  // }

  get toolTipConent() {
    if (this.validations.ifFieldNull(this.model)) {
      return "Please provide and save the fields Pre-boarding type, Employee category, Contract type and Office location country to enable this tab."
    }

    if (this.formArray.dirty) {
      return "Please save the changes to enable the tab.";
    }
  }
  showRecruitementEditHistory() {
    this.dialog.showHistory(this.profileId, this.model, "RMT");
  }

  showCandidateEditHistory() {
    this.dialog.showHistory(this.profileId, this.model, "PB");
  }

  isCountryARE(): boolean {
    const value = this.getFormControl(this.formArray, 'officeLocationCountry.id').value;
    return value == 1047;
  }

  isLocationLevant(): boolean {
    const value = this.getFormControl(this.formArray, 'officeLocationCountry.id').value;

    let retVal = true;
    if ([1054, 1053, 1055, 6250, 6251, 6252].includes(value)) {
      retVal = false;
    }
    return retVal;
  }

  isLevantNational(): boolean {

    const value = this.getFormControl(this.formArray, 'officeLocationCountry.id').value;
    let retVal = false;
    if ([1054, 1053, 1055, 6250, 6251, 6252].includes(value) && this.model.onboardingType.id == 1046) {
      retVal = true;
    }
    return retVal;
  }

  isInternationalHire(): boolean {

    return nullSafe(() => this.model.hireType.id == 729, false)

  }
  isIntern(): boolean {
    return nullSafe(() => this.model.employeeCategory.id == 715, false);
  }
  //contract types - Direct-CW,Manpower-CW,SPEC-Contractors 
  // FTTE excluded
  cw_contractTypesExcludingFTTE(): boolean {
    return nullSafe(() => (([1065,16281,16280,16282].includes(this.model.contractType?.id)) && this.model.employeeCategory?.id == 725), false);
  }
  isNationalInternalTransferWithinSameOffice(): boolean {
    return nullSafe(() => (this.isPbNational() && this.isInternalTransfer() && this.pbProfile.transferTypeID == 982) || (this.isPbNational() && this.isIntern()), false)
  }
  isCNICNeeded(): boolean {

    return nullSafe(() => this.model.nationality.id == 176 && this.model.employeeCategory.id == 3105, false)

  }

  isRapidInnovation(): boolean {

    return nullSafe(() => this.model.employeeCategory.id == 3105, false);

  }

  isRapidInnovationOrPakistan(): boolean {

    return nullSafe(() => this.model.employeeCategory.id == 3105  
    || this.model.officeLocationCountry.id == 13410  , false);

  }

  rank():string{
    return nullSafe(() => this.model.job.rank, '0');
  }

  officeLocation():number{
    
    return nullSafe(() => this.model.officeLocation.id, 0);
  }



  isInternalTransfer(): boolean {
    
    return nullSafe(() => this.model.employeeCategory.id == 717, false);
  }

  isPbNational(): boolean {
    return nullSafe(() => this.model.onboardingType.id == 1046, false);
  }

  modelDetails(): CandidateProfile {
    return this.model;
  }

  validateAcademicAttesation():boolean{
    return !([1049, 1050, 1052, 1047, 1048].includes(this.model.officeLocationCountry?.id) &&
      this.model.employeeCategory?.id != 715 || (this.model.officeLocationCountry?.id == 1047 && 
        this.model.employeeCategory?.id == 715  ))

  
  }
  
  isPreviousEmployment():boolean{
    return ([5971, 711, 713].includes(this.model.employeeCategory?.id)
     || (this.model.contractType?.id == 1063 && this.model.employeeCategory?.id == 725))  
  }

  observeAndUpdateImmCaseType() {
    const officeCountryControl = this.getFormControl(this.formArray, 'officeLocationCountry.id');
    const caseTypeControl = this.getFormControl(this.pbFormArray, 'immigrationCaseTypeID');
    if (officeCountryControl) {
      officeCountryControl.valueChanges.subscribe(value => {
        if (caseTypeControl) {
          caseTypeControl.updateValueAndValidity();
        }
      })
    }
  }

  getFormControl(formArray: UntypedFormArray, name) {
    const fg = formArray.controls.find(fg => fg.get(name));
    if (fg) {
      return fg.get(name);
    }
  }


  inviteCandidate(model) {
    this.adaptModelIfInvite(model);
    const pathWithProp  = 
    ["startDate","dateOfBirth","invitedDate","recruitmentHandoverDate","epRequestedDate","epCreatedDate",
     "candidateProfileAdditionalInfo.currentVisaExpiryDate",
     "candidateProfileAdditionalInfo.earliestJoiningDate",
     "candidateProfileAdditionalInfo.nationalities.cnicExpiryDate",
     "candidateProfileAdditionalInfo.itPersonalInfo.travellingDate",
     "candidateProfileAdditionalInfo.married.marriageDate",
     "candidateProfileAdditionalInfo.itPersonalInfo.transferDate",
     "candidateProfileAdditionalInfo.attestationCompletedDate",
     "candidateProfileAdditionalInfo.lastEmployerDetail.lastEmployerStartDate",
     "candidateProfileAdditionalInfo.lastEmployerDetail.lastEmployerEndDate",
     "startDateCW","confirmedEnddateCW","lastWorkingday"
    ];
    this.common.updateDateProperty(this.model, pathWithProp);
    this.candidateApi.inviteForRecuriment(true, model).pipe(catchError((err: HttpErrorResponse) => {
      return this.toast.handleServerValidationMessage(err);
    }), finalize(() => {
      this.loader.clear();
      this.disableButton = false;
    })
    ).subscribe(result => {
      if (result.statusCode === HttpStatusCode.Created && result.data) {
        if (result.errorCode === 2002) {
          this.toast.warning("Email not sent");
        }
        this.formArray.markAsPristine();
        this.model = result.data;
        this.bindAdditionalPBSteps();
        this.profileId = result.data.id;
        this.common.candidateId = result.data.id;
        this.toast.success("Profile submitted successfully!");
        this.fsm.send(new SENDINVITE());

        this.router.navigateByUrl(`/recruitment/candidates`);
      }
    }, error => {
      Logger.error(error);
    });
  }


  directInvite(model: CandidateProfile) {
    model.isDirectMailInvite = true;
    this.sendInvite(model);
  }


  sendInvite(model: CandidateProfile) {
    if (this.formArray.invalid) {
      this.formArray.markAllAsTouched();
      this.navigateToFirstInvalidTab(this.formArray);
      this.toast.warning("Please fill the mandatory fields");
      return;
    }

    if (!this.validations.docMandatory(this.uploadedFiles)) {
      this.toast.warning("Please upload all mandatory documents");
      return;
    }

    if (this.model.inviteEnabled || model.isDirectMailInvite) {
      this.dialog.showConfirmationBox('Send invitation?',
        `Do you really want to send  invitation to '${model.emailID}'`, () => {
          this.loader.show();
          this.inviteCandidate(model);
        }, () => {
          model.isDirectMailInvite = false;
        }
      );
    } else {

      this.loader.show();
      this.inviteCandidate(model);
    }

  }


  get CanSendMail() {

    return this.model.status.id == StatusTypes.INVITED ? true : false
  }


  sendInviteMail() {

    this.dialog.showConfirmationBox('Resend invitation?',
      `Do you  want to resend  invitation to '${this.model.emailID}' ? This will reset candidate's current login credentials in recruitment portal `, () => {
        this.loader.show();
        this.candidateApi.resetPasswordAndsendMail(this.model.id).pipe(catchError((err: HttpErrorResponse) => {
          return this.toast.handleServerValidationMessage(err);
        }), finalize(() => {
          this.loader.clear();
        })
        ).subscribe(result => {
          if (result.statusCode === HttpStatusCode.OK && result.data) {
            if (result.errorCode === 2002) {
              this.toast.warning("Email not sent");
            }

            this.toast.success("Invitation sent to candidate's registered email address");
            this.router.navigateByUrl(`/recruitment/candidates`);
          }
        }, error => {
          Logger.error(error);
        });
      });
  }


  cancelInvite() {

    this.dialog.showApprovalBox((cmt) => {
      this.comment.commentType = CommentTypes.Recruitment;
      this.comment.candidateProfileId = this.profileId;
      this.comment.statusId = StatusTypes.CANCELLEDINVITE;
      this.comment.comment = this.trimNotesAndComments(cmt.Comment);
      this.loader.show();
      this.candidateApi.cancelInvite(this.model.id, this.comment).pipe(catchError((err: HttpErrorResponse) => {
        return this.toast.handleServerValidationMessage(err);
      }), finalize(() => {
        this.loader.clear();
      })
      ).subscribe(result => {
        if (result.statusCode === HttpStatusCode.OK && result.data) {
          this.toast.success("Invitation cancelled, user won't be able to login to recruitment portal any further.");
          this.router.navigateByUrl(`/recruitment/candidates`);
        }
      }, error => {
        Logger.error(error);
      });
    });
  }

  bindAdditionalPBSteps() {
    this.additionalSteps = this.stepService.getAdditionalPbSteps(this.model);
  }
  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
bindReorderedFields(){
  // here we bind the values that was reordered from profile step to addtional info
    this.model.gender = this.model.candidateProfileAdditionalInfo.gender;
    this.model.dateOfBirth = this.model.candidateProfileAdditionalInfo.dateOfBirth;
}
}
